import { client } from '@api/client';
import { URL } from '@api/urls';

import { IId } from '@interfaces/common/common';
import { IOrganisationSwitchEntity } from '@interfaces/organisation/organisations';

const {
	organisationSwitch,
	organisationSwitchFavouriteAdd,
	organisationSwitchFavouriteRemove,
} = URL;

export const getOrganisationsSwitch = (): Promise<IOrganisationSwitchEntity[]> => {
	return client.get(organisationSwitch);
};

export const addOrganisationsSwitch = (params: IId): Promise<void> => {
	return client.post(organisationSwitchFavouriteAdd, params);
};

export const removeOrganisationsSwitch = (params: IId): Promise<void> => {
	return client.post(organisationSwitchFavouriteRemove, params);
};
